import { render, staticRenderFns } from "./SupplierOnboardingSecondCheckPoint.vue?vue&type=template&id=bd647bbc&"
import script from "./SupplierOnboardingSecondCheckPoint.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingSecondCheckPoint.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingSecondCheckPoint.vue?vue&type=style&index=0&id=bd647bbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports